<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

/**
 * Main Layout
 */
export default {
    components: {
        Vertical,
        Horizontal,
    },
    data() {
        return {
            totalInCart: 0,
            totalInFavourite: 0
        };
    },
    computed: {
        ...layoutComputed,
    },
    mounted() {
        document.body.classList.remove('authentication-bg')
    },
    methods: { 
        callVerticalandTriggerTopbar(){
           this.$refs.connectVertical.triggerTopBar();
        }
    },
};
</script>

<template>
<div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType" ref="connectVertical">
        <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>
</div>
</template>
